




































































































































































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'
import Attachments from '@/components/Controls/Attachments.vue';

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'providers', 'product_types'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required },
      code: { required },
      code_1c: {  },
      type: { required },
      raw_materials_id: { required },
      subgroup_id: { required },
      manufacturers_id: { required },
      // тип обязателен только у сырья «общей линии»
      common_product_type_id: {
        required: requiredIf(function(this: any) {
          return !!this.form && !!this.form.is_common;
        })
      },
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class IngredientsManagerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  providers!: any[]
  product_types!: any[]
  ids: any[] = []

  // уже выбранные типы продуктов: исключаются из выпадающего списка (без дублей)
  get productTypeIds() {
    return (this.product_types || []).map((item: any) => item.product_type_id);
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, file);
  }

  removeFile( idx: number, data: any) {
    this.form.attachments.splice(idx, 1)
  }

  addProvider(provider: any) {
    this.$store.dispatch(`${STORE_KEY}/addProvider`, {
      provider
    }).then(() => {
      this.ids = this.providers.map((item: any) => {
        return item.id
      })
    });
  }
  delProvider(provider: any) {
    this.$store.dispatch(`${STORE_KEY}/delProvider`, {
      provider
    }).then(() => {
      this.ids = this.providers.map((item: any) => {
        return item.id
      })
    })
  }

  addProductType(productType: any) {
    this.$store.dispatch(`${STORE_KEY}/addProductType`, {
      productType
    });
  }
  delProductType(productType: any) {
    this.$store.dispatch(`${STORE_KEY}/delProductType`, {
      productType
    });
  }

  setArchive() {
    this.$store.dispatch(`${STORE_KEY}/setArchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть архивирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch((e: any) => {
        console.log(e)
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  setUnarchive() {
    this.$store.dispatch(`${STORE_KEY}/setUnarchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть активирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch((e) => {
        console.log(e)
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })    
  }

  /** При выключении «общей линии» тип продукта не имеет смысла — очищаем:
   *  иначе обязательное-при-включении поле утащит старое значение в БД.
   *  v-model уже записал новое значение свитка в форму. */
  onCommonLineSwitch() {
    if (!this.form.is_common) {
      this.changeValue('common_product_type_id', null);
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    if (this.$v.form[field]) {
      // @ts-ignore
      this.$v.form[field].$touch();
    }
  }
  changeValueProvider(idx: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeProviderValue`, {
      idx, field, newValue: value
    });
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

